import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

//@ts-ignore
import Account from '@/Pages/Account/routes'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
    {
        path: "*", 
        name: '404',
        component: () => import('@/Layouts/404.vue')
    },
    {
        path: '/',
        component: () => import('@/Layouts/Default.vue'),
        children: [
            { path: '/', name: 'links', component: () => import('@/Pages/Dashboard/Links.vue') },
            { path: '/social-links', name: 'social-links', component: () => import('@/Pages/Dashboard/SocialLinks.vue') },
            { path: '/builder', name: 'builder', component: () => import('@/Pages/Dashboard/Builder.vue') },
            { path: '/builder/create/', name: 'builder-create', component: () => import('@/Pages/Dashboard/BuilderEdit.vue') },
            { path: '/builder/edit/:themeId', name: 'builder-edit', component: () => import('@/Pages/Dashboard/BuilderEdit.vue') },
            { path: '/appearance', name: 'appearance', component: () => import('@/Pages/Dashboard/Appearance.vue') },
        ],
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/',
        component: () => import('@/Layouts/FullPageSidebar.vue'), 
        children: [
            
            { path: '/media', name: 'media', component: () => import('@/Pages/Media.vue') },
            { path: '/settings', name: 'settings', component: () => import('@/Pages/Settings.vue') },
        ],
        meta: {
            requiresAuth: true,
        }
    },
    Account,
    // {
    //     path: '/:username',
    //     component: () => import('@/views/FrontPage.vue'),
    //     props: true,
    // },
]

const router = new VueRouter({
  routes,
  mode: 'history',
})

export default router
